import { toast } from "App";
import CustomComponent from "./CustomComponent";
import { MessageMethods, NoticeType, MessageMethodType } from "./interface";
import { MD5 } from 'crypto-js'

const methods: (keyof MessageMethods)[] = [
  "success",
  "info",
  "warning",
  "error",
  "loading",
];

const staticMethods = {} as MessageMethods;

const DURATION_TYPE = {
  // millisecond
  success: 2000,
  info: 2000,
  warning: 10000,
  error: 5000,
  loading: 2000,
};

const showMessage = (type: NoticeType, args: Parameters<MessageMethodType>) => {
  const [content, options, onCloseCallback] = args;
  const toastKey = `${type}-${JSON.stringify(content)}`;
  const toastId = MD5(toastKey).toString()

  /**
   * Due to the asynchronous nature of Chakra's toast closing mechanism, 
   * there are instances where a toast is no longer active but hasn't been removed from the DOM yet. 
   * Consequently, if a user repeatedly spams the toast creation, it can lead to the toasts becoming permanently stuck. 
   * Therefore, it's necessary to check both conditions: the toast's active state and its presence in the DOM.
   */
  const toastEl = document.getElementById(toastId);
  if (toast.isActive(toastId) || toastEl) return;
  const duration = options?.duration ?? DURATION_TYPE[type];

  toast({
    id: toastId,
    status: type,
    position: options?.placement ?? "top",
    duration,
    render: ({ onClose }) => (
      <CustomComponent
        id={toastId}
        status={type}
        onClose={onClose}
        onCloseCallback={onCloseCallback}
        content={content}
      />
    ),
  });
};

methods.forEach((type: keyof MessageMethods) => {
  staticMethods[type] = (...args: Parameters<MessageMethodType>) =>
    showMessage(type, args);
});

export default staticMethods;
